import { render, staticRenderFns } from "./PgaSlider.vue?vue&type=template&id=359c90d6&"
import script from "./PgaSlider.vue?vue&type=script&lang=ts&"
export * from "./PgaSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlideYTransition,VSlider})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359c90d6')) {
      api.createRecord('359c90d6', component.options)
    } else {
      api.reload('359c90d6', component.options)
    }
    module.hot.accept("./PgaSlider.vue?vue&type=template&id=359c90d6&", function () {
      api.rerender('359c90d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaSlider.vue"
export default component.exports